import React from "react";
import MapComponent from "pages/Rostering/TimeSheet/MapComponent";
import { TimesheetTabSectionHeader } from "../../../components/TimesheetRevamp/TimesheetTabPrimitives";

const Location = ({ shiftDetails }) => {
  return (
    <div className="timesheet-tab-content space-y-3">
      <TimesheetTabSectionHeader
        title="Shift location"
        subtitle="Clock-in and clock-out locations for this shift"
      />
      <div className="overflow-hidden rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-2">
        <MapComponent selectedTimeSheet={shiftDetails} markShiftLocation />
      </div>
    </div>
  );
};

export default Location;
